/* eslint-disable max-len */
import { SvgProps } from './types'

export const HandMoneyIcon = ({ color, className, ...rest }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg
      width="42"
      height="40"
      viewBox="0 0 42 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <path
        d="M7.67773 27.8133L11.1294 26.6215C12.6012 26.1135 14.2131 26.1815 15.6369 26.8174L17.1408 27.4894C17.6207 27.7014 18.1367 27.8133 18.6646 27.8133H26.1279C28.0237 27.8133 29.5635 29.3532 29.5635 31.249C29.5635 31.8449 29.0796 32.3249 28.4877 32.3249H20.1965"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.5253 30.7291L35.2407 27.9254C36.9606 27.0855 38.9924 27.4494 40.3122 28.7613C40.5722 29.0173 40.5042 29.4532 40.1803 29.6252L29.1694 35.4366C28.7054 35.6966 23.2179 37.5924 21.4141 38.1124C20.9502 38.2443 20.4622 38.2763 19.9943 38.1684C19.8503 38.1364 19.7103 38.0924 19.5703 38.0444L12.355 35.4606C11.7391 35.2126 11.0392 35.2566 10.4592 35.5766L7.6875 37.1165"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.53125 37.6564H6.65874C7.18668 37.6564 7.61064 37.2285 7.61064 36.7045V27.9894C7.61064 27.4614 7.18268 27.0375 6.65874 27.0375H1.53125"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.5558 11.9669H11.8262V23.2018H35.5558V11.9669Z"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.3014 19.0532C25.1116 18.7176 25.4963 17.7888 25.1607 16.9786C24.8251 16.1684 23.8963 15.7837 23.0861 16.1193C22.2759 16.4549 21.8912 17.3837 22.2268 18.1939C22.5624 19.0041 23.4912 19.3888 24.3014 19.0532Z"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.5446 20.878V20.6901C30.5446 19.7622 31.2925 19.0022 32.2204 18.9902V15.8266H32.0284C31.2005 15.7986 30.5446 15.1226 30.5446 14.2987H16.8379C16.8379 15.1266 16.178 15.8026 15.3541 15.8226H15.1621V18.9902C16.09 19.0022 16.8379 19.7582 16.8379 20.6901V20.878H30.5446Z"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9023 10.0671L16.5501 4.62366L28.7849 10.5711"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0977 4.3317L23.9494 1.53198L32.2685 9.99514"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
